import { ButtonAttrs, ButtonProps, ButtonWidget } from '@tableau/widgets';
import React from 'react';

function ButtonWithSpinnerComponent(props: Omit<ButtonProps, 'handleClick'> & ButtonAttrs): JSX.Element {
  return <ButtonWidget {...props} style={{ verticalAlign: 'top', ...props.style }} />;
}

/**
 * A button with an optional spinner shown within it. Used for action dialogs and the like.
 * When shown, the spinner appears in place of the button text, as specified in the
 * design guidelines: http://design/guidelines/components/activity-spinner
 * 
 * @deprecated use `showSpinner` prop on `ButtonWidget`
 */
export const ButtonWithSpinner = React.memo(ButtonWithSpinnerComponent);
